module.exports = __webpack_public_path__ + "img/tab2.ec3e6c9a.png";